import React, { createContext, useState } from 'react'

export const TermsContext = createContext()

const TermsContextProvider = ({ children }) => {
    const [showModal, setShowModal] = useState(true)

    const manageModal = () => {
        setShowModal(false)
    }

    const contextValues = {
        showModal,
        manageModal,
    }

    return <TermsContext.Provider value={contextValues}>{children}</TermsContext.Provider>
}
export default TermsContextProvider
